<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ddlHelper, sessionHelper } from "@/utils";
import { SESSION } from "@/constants";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import i18n from "@/i18n";
import { LOOKUP_MODULE } from '@/state/modules/lookup'
import { PRODUCT_MODULE } from '@/state/modules/product'
import { lookupMethods, productMethods } from "@/state/helpers";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Multiselect from "vue-multiselect";

export default {
    page: {
        title: i18n.t("label.createX", [i18n.t("module.halex")]),
    },
    components: { Layout, PageHeader, DatePicker, Multiselect },
    beforeRouteLeave(to, from, next) {
        if (to.name != "Product-halex-listing") {
            sessionHelper.clearSearch(SESSION.PRODUCT_HALEX_SEARCH);
        }
        next();
    },
    computed: {
        ...mapState(PRODUCT_MODULE, ["status"]),
        ...mapState(LOOKUP_MODULE),
        formDdl() {
            return this.$store.state.lookup.formDdl;
        },
        classDdl() {
            return this.$store.state.lookup.classDdl;
        },
        // moaDdl() {
        //     return this.$store.state.lookup.moaDdl;
        // },
        typeDdl() {
            return this.$store.state.lookup.typeDdl;
        },
        purposeDdl() {
            return this.$store.state.lookup.purposeDdl;
        },
        brandDdl() {
            return this.$store.state.lookup.brandDdl;
        },
    },
    data() {
        const times = ddlHelper.getShellLifeTime();
        return {
            title: i18n.t("label.createX", [i18n.t("module.halex")]),
            items: [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.halex"),
                    href: "/product-halex",
                },
                {
                    text: i18n.t("label.createX", [i18n.t("module.halex")]),
                    active: true,
                },
            ],
            submitted: false,
            isLoading: true,
            statusDdl: ddlHelper.getActivationStatus(false, true),
            timeDdl: times,
            permissions: sessionHelper.getPermissions(),
            createPermission: null,
            createForm: {
                formulationID: "",
                classID: "",
                // moaID: "",
                typeID: "",
                purposeID: "",
                brandName: "",
                lrmp: "",
                referenceNumber: "",
                dor: "",
                expiredDate: "",
                dorSubmissionDate: "",
                remark: "",
                approvalDate: "",
                isRegisterCert: "",
                shelfLifeProduction: "",
                endorseLabel: "", 
            },
        };
    },
    validations: {
        createForm: {
            formulationID: { required },
            classID: { required },
            // moaID: { required },
            typeID: { required },
            purposeID: { required },
            brandName: { required },
            // lrmp: { required },
            referenceNumber: { required },
            // dor: { required },
            // expiredDate: { required },
            // dorSubmissionDate: { required },
            // approvalDate: { required },
            // endorseLabel: { required },
            // shelfLifeTime: {
            //     required: function () {
            //         if(this.createForm.shelfLifeProduction === true) {
            //             return false;
            //         }
            //         else {
            //             return true;
            //         }
            //     }
            // },
        },
    },
    async created() {
        await this.validPermissions();
        this.getAllLookup();
    },
    methods: {
        ...productMethods,
        ...lookupMethods,
        async validPermissions() {
            var jsonPermissions = JSON.parse(this.permissions)
            if (jsonPermissions.some(p => p.code === "RND_HPRODUCT_HPC")) {
                this.createPermission = true;
            }
            else {
                this.createPermission = false;
            }
        },
        getAllLookup() {
            this.isLoading = true;
            this.lookupForm({ hasOptionAll: false });
            this.lookupClass({ hasOptionAll: false });
            this.lookupPurpose({ hasOptionAll: false });
            this.lookupBrand({ hasOptionAll: false });
            // this.lookupMOA({ hasOptionAll: false });
            this.lookupType({ hasOptionAll: false });
            this.isLoading = false;
        },
        requestCreate() {
            this.submitted = true;
            // stop here if form is invalid
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    formulationID: this.createForm.formulationID.value,
                    classID: this.createForm.classID.value,
                    // moaID: this.createForm.moaID.value,
                    typeID: this.createForm.typeID.value,
                    purposeID: this.createForm.purposeID.value,
                    brandName: this.createForm.brandName,
                    lrmp: this.createForm.lrmp,
                    referenceNumber: this.createForm.referenceNumber,
                    dor: this.createForm.dor,
                    expiredDate: this.createForm.expiredDate,
                    dorSubmissionDate: this.createForm.dorSubmissionDate,
                    remark: this.createForm.remark,
                    approvalDate: this.createForm.approvalDate,
                    isRegisterCert: this.createForm.isRegisterCert,
                    shelfLifeProduction: this.createForm.shelfLifeProduction,
                    endorseLabel: this.createForm.endorseLabel,
                    shelfLifeTime: this.createForm.shelfLifeTime.code,
                };

                if (this.createPermission == true) {
                    this.createProductHalex({ data });
                }
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col">
                <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;"
                    v-if="isLoading == true">
                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                </div>
                <div class="card" v-else>
                    <div class="card-body">
                        <form @submit.prevent="requestCreate" v-if="createPermission == true">
                            <!--  -->

                            <div class="row">
                                <div class="col-md-6">
                                    <b-form-group id="formulationID" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('module.form')" label-for="formulationID">
                                        <multiselect v-model="createForm.formulationID"
                                            deselect-label="Can't remove this value" track-by="value" label="text"
                                            placeholder="Select one" :options="formDdl" :searchable="true"
                                            :allow-empty="false">
                                        </multiselect>
                                        <div v-if="submitted && !$v.createForm.formulationID.required"
                                            style="color: #ff3d60; font-size: 80%">
                                            <span>{{ $t("message.atLeastOneSelectedX", [$t("module.form")])
                                                }}</span>
                                        </div>
                                    </b-form-group>
                                </div>

                                <div class="col-md-6">
                                    <b-form-group id="classID" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('module.class')" label-for="classID">
                                        <multiselect v-model="createForm.classID"
                                            deselect-label="Can't remove this value" track-by="value" label="text"
                                            placeholder="Select one" :options="classDdl" :searchable="true"
                                            :allow-empty="false">
                                        </multiselect>
                                        <div v-if="submitted && !$v.createForm.classID.required"
                                            style="color: #ff3d60; font-size: 80%">
                                            <span>{{ $t("message.atLeastOneSelectedX", [$t("module.class")])
                                                }}</span>
                                        </div>
                                    </b-form-group>
                                </div>

                                <!-- <div class="col-md-6">
                                    <b-form-group id="moaID" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('module.moa')" label-for="moaID">
                                        <multiselect v-model="createForm.moaID" deselect-label="Can't remove this value"
                                            track-by="value" label="text" placeholder="Select one" :options="moaDdl"
                                            :searchable="true" :allow-empty="false">
                                        </multiselect>
                                        <div v-if="submitted && !$v.createForm.moaID.required"
                                            style="color: #ff3d60; font-size: 80%">
                                            <span>{{ $t("message.atLeastOneSelectedX", [$t("module.moa")])
                                                }}</span>
                                        </div>
                                    </b-form-group>
                                </div> -->

                                <div class="col-md-6">
                                    <b-form-group id="typeID" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('module.type')" label-for="typeID">
                                        <multiselect v-model="createForm.typeID"
                                            deselect-label="Can't remove this value" track-by="value" label="text"
                                            placeholder="Select one" :options="typeDdl" :searchable="true"
                                            :allow-empty="false">
                                        </multiselect>
                                        <div v-if="submitted && !$v.createForm.typeID.required"
                                            style="color: #ff3d60; font-size: 80%">
                                            <span>{{ $t("message.atLeastOneSelectedX", [$t("module.type")])
                                                }}</span>
                                        </div>
                                    </b-form-group>
                                </div>

                                <div class="col-md-6">
                                    <b-form-group id="purposeID" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('module.purpose')" label-for="purposeID">
                                        <multiselect v-model="createForm.purposeID"
                                            deselect-label="Can't remove this value" track-by="value" label="text"
                                            placeholder="Select one" :options="purposeDdl" :searchable="true"
                                            :allow-empty="false">
                                        </multiselect>
                                        <div v-if="submitted && !$v.createForm.purposeID.required"
                                            style="color: #ff3d60; font-size: 80%">
                                            <span>{{ $t("message.atLeastOneSelectedX", [$t("module.purpose")])
                                                }}</span>
                                        </div>
                                    </b-form-group>
                                </div>

                                <div class="col-md-6">
                                    <b-form-group id="brandName" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('label.name')" label-for="brandName">
                                        <b-form-input id="title" v-model.trim="createForm.brandName" :class="{
                                            'is-invalid': submitted && !$v.createForm.brandName.required
                                        }"></b-form-input>
                                        <div v-if="submitted && !$v.createForm.brandName.required"
                                            class="invalid-feedback">
                                            <span>{{ $t("message.requiredX", [$t("label.name")]) }}</span>
                                        </div>
                                    </b-form-group>
                                </div>

                                <div class="col-md-6">
                                    <b-form-group id="lrmp" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('label.lrmp')" label-for="lrmp">
                                        <b-form-input id="title" v-model.trim="createForm.lrmp"></b-form-input>
                                        <!-- <div v-if="submitted && (!$v.createForm.lrmp.required)"
                                            class="invalid-feedback">
                                            <span>{{ $t("message.requiredX", [$t("label.lrmp")]) }}</span>
                                        </div> -->
                                    </b-form-group>
                                </div>

                                <div class="col-md-6">
                                    <b-form-group id="referenceNumber" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('label.XreferenceNumber', [$t('module.halex')])"
                                        label-for="referenceNumber">
                                        <b-form-input id="title" v-model.trim="createForm.referenceNumber" :class="{
                                            'is-invalid': submitted && !$v.createForm.referenceNumber.required
                                        }"></b-form-input>
                                        <div v-if="submitted && !$v.createForm.referenceNumber.required"
                                            class="invalid-feedback">
                                            <span>{{ $t("message.requiredX", [$t("label.XreferenceNumber",
                                                [$t('module.halex')])]) }}</span>
                                        </div>
                                    </b-form-group>
                                </div>

                                <div class="col-lg-6">
                                    <b-form-group id="dor" label-cols-sm="4" label-cols-lg="4" :label="$t('label.dor')"
                                        label-for="dor">
                                        <date-picker v-model="createForm.dor" type="date" format="YYYY-MM-DD"
                                            value-type="format" placeholder="Select date"></date-picker>

                                        <!-- <div v-if="submitted && !$v.createForm.dor.required" class="invalid-feedback"
                                            style="display: block !important;">
                                            <span>{{ $t("message.requiredX", [$t("label.dor")]) }}</span>
                                        </div> -->
                                    </b-form-group>
                                </div>

                                <div class="col-lg-6">
                                    <b-form-group id="expiredDate" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('label.doe')" label-for="expiredDate">
                                        <date-picker v-model="createForm.expiredDate" type="date" format="YYYY-MM-DD"
                                            value-type="format" placeholder="Select date"></date-picker>

                                        <!-- <div v-if="submitted && !$v.createForm.expiredDate.required"
                                            class="invalid-feedback" style="display: block !important;">
                                            <span>{{ $t("message.requiredX", [$t("label.doe")]) }}</span>
                                        </div> -->
                                    </b-form-group>
                                </div>

                                <div class="col-lg-6">
                                    <b-form-group id="dorSubmissionDate" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('label.dorSubmissionDate')" label-for="dorSubmissionDate">
                                        <date-picker v-model="createForm.dorSubmissionDate" type="date"
                                            format="YYYY-MM-DD" value-type="format"
                                            placeholder="Select date"></date-picker>

                                        <!-- <div v-if="submitted && !$v.createForm.dorSubmissionDate.required"
                                            class="invalid-feedback" style="display: block !important;">
                                            <span>{{ $t("message.requiredX", [$t("label.dorSubmissionDate")]) }}</span>
                                        </div> -->
                                    </b-form-group>
                                </div>

                                <div class="col-lg-6">
                                    <b-form-group id="approvalDate" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('label.approvalDate')" label-for="approvalDate">
                                        <date-picker v-model="createForm.approvalDate" type="date" format="YYYY-MM-DD"
                                            value-type="format" placeholder="Select date"></date-picker>

                                        <!-- <div v-if="submitted && !$v.createForm.approvalDate.required"
                                            class="invalid-feedback" style="display: block !important;">
                                            <span>{{ $t("message.requiredX", [$t("label.approvalDate")]) }}</span>
                                        </div> -->
                                    </b-form-group>
                                </div>

                                <div class="col-md-6">
                                    <b-form-group id="endorseLabel" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('label.endorseLabel')" label-for="lrmp">
                                        <b-form-input id="title" v-model.trim="createForm.endorseLabel"></b-form-input>
                                        <!-- <div v-if="submitted && (!$v.createForm.endorseLabel.required)"
                                            class="invalid-feedback">
                                            <span>{{ $t("message.requiredX", [$t("label.endorseLabel")]) }}</span>
                                        </div> -->
                                    </b-form-group>
                                </div>

                                <div class="col-lg-6">
                                    <b-form-group id="remark" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('label.remark')" label-for="remark">
                                        <textarea v-model="createForm.remark" class="form-control" name="textarea"
                                            rows="5"></textarea>
                                        <!-- <b-form-input id="remark" v-model.trim="createForm.remark"></b-form-input> -->
                                    </b-form-group>
                                </div>

                                <div class="col-md-6">
                                    <b-form-group id="shelfLifeTime" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('label.shelfLifeTimeYear')" label-for="shelfLifeTime">
                                        <multiselect v-model="createForm.shelfLifeTime" track-by="code" label="name"
                                            placeholder="Select one" :options="timeDdl" :searchable="true"
                                            :allow-empty="true">
                                        </multiselect>
                                    </b-form-group>
                                </div>

                                <div class="col-lg-12 d-flex align-items-center justify-content-end">
                                    <b-form-group style="padding-right: 10px;">
                                        <b-form-checkbox id="isRegisterCert" v-model="createForm.isRegisterCert"
                                            :value="true" :unchecked-value="false" switch>
                                            {{ $t('label.isRegisterCert') }}
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <!-- <b-form-group>
                                        <b-form-checkbox id="shelfLifeProduction"
                                            v-model="createForm.shelfLifeProduction" :value="true"
                                            :unchecked-value="false" switch>
                                            {{ $t('label.isShelfLifeProduction') }}
                                        </b-form-checkbox>
                                    </b-form-group> -->
                                </div>

                            </div>
                            <div class="mt-4 text-center" style="float: right">
                                <button class="btn btn-primary w-md waves-effect waves-light" style="margin-right: 10px"
                                    type="submit" :disabled="status.create">
                                    {{ $t("label.createX", [$t("module.halex")]) }}
                                </button>
                            </div>
                        </form>
                        <div style="text-align: center;" v-else>
                            {{ $t('message.noPermissionMessage') }}
                        </div>
                    </div>
                </div>
                <!-- end card -->
            </div>
            <!-- end col -->
        </div>
    </Layout>
</template>